/**
 * Contact addresses for the active app: enquiries (access, purchasing) route to
 * the suite's own inbox where it has one and the general address otherwise,
 * support to the support desk. Both carry the app name in the subject.
 */

import { getProductSuite } from './availability';
import type { AppConfig, ProductSuiteId } from './types';

const DEFAULT_ENQUIRY_EMAIL = 'hello@abley.com';
const SUITE_ENQUIRY_EMAIL: Partial<Record<ProductSuiteId, string>> = {
	safesystem: 'safesystem@abley.com'
};

export const SUPPORT_EMAIL = 'support@abley.com';

const ENQUIRY_SUBJECT = 'Abley Spatial enquiry';
const SUPPORT_SUBJECT = 'Abley Spatial support';

// `app` is null on routes that set no app (the landing page), where the key
// modals still render.
export function enquiryEmail(app: AppConfig<unknown> | null): string {
	const suite = app ? getProductSuite(app.id) : undefined;
	return (suite && SUITE_ENQUIRY_EMAIL[suite]) ?? DEFAULT_ENQUIRY_EMAIL;
}

function mailto(email: string, subject: string, app: AppConfig<unknown> | null): string {
	const withApp = app ? `${subject}: ${app.name}` : subject;
	return `mailto:${email}?subject=${encodeURIComponent(withApp)}`;
}

export function enquiryMailto(app: AppConfig<unknown> | null): string {
	return mailto(enquiryEmail(app), ENQUIRY_SUBJECT, app);
}

export function supportMailto(app: AppConfig<unknown> | null): string {
	return mailto(SUPPORT_EMAIL, SUPPORT_SUBJECT, app);
}
